import React, { ChangeEvent, FC } from "react";

import { SafeArgonBox, SafeArgonTypography } from "0.Mine/4.Argon/ArgonComponents";

interface ColorPickerProps {
  label: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const ColorPicker: FC<ColorPickerProps> = ({ label, value, onChange }) => (
  <SafeArgonBox sx={{ display: "flex", alignItems: "center", gap: 2 }}>
    <SafeArgonTypography>{label}</SafeArgonTypography>
    <SafeArgonBox
      sx={{
        width: 24,
        height: 24,
        borderRadius: 1,
        backgroundColor: value,
        border: "1px solid #ccc",
      }}
    />
    <input
      type="color"
      value={value}
      onChange={onChange}
      style={{
        border: "none",
        padding: 0,
        background: "transparent",
        width: 32,
        height: 32,
        cursor: "pointer",
      }}
    />
  </SafeArgonBox>
);
